var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionTypeTfImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 117,
    viewBox: "0 0 127 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.5488,
    y: 22.8994,
    width: 85.8692,
    height: 30.9925,
    rx: 2.73993,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2818,
    y: 22.2324,
    width: 85.2033,
    height: 30.3266,
    rx: 2.40697,
    stroke: "#35363A",
    strokeWidth: 0.665931,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8853,
    y: 28.4902,
    width: 18.9055,
    height: 18.9055,
    rx: 9.45277,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.0459 38.3981L36.9008 41.253L43.4263 34.7275",
    stroke: "#35363A",
    strokeWidth: 0.815684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.2637,
    y: 33.4785,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2637,
    y: 33.4785,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2637,
    y: 33.4785,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2637,
    y: 33.4785,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2637,
    y: 39.8604,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2637,
    y: 39.8604,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2637,
    y: 39.8604,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2637,
    y: 39.8604,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#9BBAC1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23.0625,
    y: 55.8066,
    width: 85.8692,
    height: 30.9925,
    rx: 2.73993,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2818,
    y: 55.4396,
    width: 85.2033,
    height: 30.3266,
    rx: 2.40697,
    stroke: "#35363A",
    strokeWidth: 0.665931,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3989,
    y: 61.3975,
    width: 18.9055,
    height: 18.9055,
    rx: 9.45277,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.7645 67.2236L34.8384 75.1498",
    stroke: "#35363A",
    strokeWidth: 0.816394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7645 75.1498L34.8384 67.2236",
    stroke: "#35363A",
    strokeWidth: 0.816394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.7773,
    y: 66.3867,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7773,
    y: 66.3867,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7773,
    y: 66.3867,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7773,
    y: 66.3867,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7773,
    y: 72.7686,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7773,
    y: 72.7686,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7773,
    y: 72.7686,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7773,
    y: 72.7686,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#E3DFE9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.74756 50.6126L74.9121 10.2988L4.74756 50.6126Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.574 26.6101L115.042 23.4268L109.574 26.6101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.029 32.8298L118.498 29.6465",
    stroke: "#E5E5E5",
    strokeWidth: 16.5442,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.524 70.6878C113.377 70.7769 113.998 71.5422 113.909 72.3956C113.82 73.249 113.054 73.8696 112.201 73.7805C111.348 73.6914 110.727 72.9261 110.816 72.0727C110.905 71.2193 111.67 70.5987 112.524 70.6878Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.770189
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8382 102.401C23.2416 102.548 24.2621 103.806 24.1156 105.21C23.9691 106.613 22.7106 107.633 21.3073 107.487C19.9039 107.34 18.8834 106.082 19.0299 104.679C19.1764 103.275 20.4349 102.255 21.8382 102.401Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.26652
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6156 6.20104C59.019 6.34757 60.0395 7.60599 59.8929 9.00938C59.7464 10.4128 58.488 11.4333 57.0846 11.2867C55.6812 11.1402 54.6607 9.88178 54.8073 8.47839C54.9538 7.07499 56.2122 6.05452 57.6156 6.20104Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.26652
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3477 30.877C6.99232 30.877 7.51571 31.4003 7.51571 32.045C7.51571 32.6896 6.99232 33.213 6.3477 33.213C5.70307 33.213 5.17969 32.6896 5.17969 32.045C5.17969 31.4003 5.70307 30.877 6.3477 30.877Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.925776
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1392 107.045C89.7838 107.045 90.3072 107.568 90.3072 108.213C90.3072 108.858 89.7838 109.381 89.1392 109.381C88.4946 109.381 87.9712 108.858 87.9712 108.213C87.9712 107.568 88.4946 107.045 89.1392 107.045Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.925776
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5391 5.14648L95.8724 0.651957",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0332 2.26367L97.5277 3.59705",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1582 73.7529L4.32722 69.2129",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54785 70.9277L6.0879 72.0967",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.61 94.0361L101.525 89.438",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8462 91.3037L103.444 92.2181",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeTfImg);
export default __webpack_public_path__ + "static/media/question_type_tf_img.cd2e7458c15183a1fa80190a7fbce8e0.svg";
export { ForwardRef as ReactComponent };